var _defineProperty = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');
var helpers = require('../helpers.js');

/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */
var httpContextIntegration = core.defineIntegration(function () {
  return {
    name: 'HttpContext',
    preprocessEvent: function preprocessEvent(event) {
      var _event$request, _event$request2;
      // if none of the information we want exists, don't bother
      if (!helpers.WINDOW.navigator && !helpers.WINDOW.location && !helpers.WINDOW.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      var url = ((_event$request = event.request) === null || _event$request === void 0 ? void 0 : _event$request.url) || core.getLocationHref();
      var _ref = helpers.WINDOW.document || {},
        referrer = _ref.referrer;
      var _ref2 = helpers.WINDOW.navigator || {},
        userAgent = _ref2.userAgent;
      var headers = _objectSpread(_objectSpread(_objectSpread({}, (_event$request2 = event.request) === null || _event$request2 === void 0 ? void 0 : _event$request2.headers), referrer && {
        Referer: referrer
      }), userAgent && {
        'User-Agent': userAgent
      });
      var request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
        url: url
      }), {}, {
        headers: headers
      });
      event.request = request;
    }
  };
});
exports.httpContextIntegration = httpContextIntegration;